<template>
    <PageFrame v-if="docId">
        <h1>Edit "{{title}}" Job</h1>
        <div class="content">
            <!-- START SIDEBAR -->
            <div class="content-sidebar">
                <!-- Company -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        Company Name
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="companyError"
                        errorMsg="Please include the company name" />
                    <OSJInput
                        placeholdertext="Company Name"
                        :error="companyError"
                        v-model="company">
                    </OSJInput>
                </div>
                <!-- Logo -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size">
                        Company Logo
                    </OSJLabel>
                    <OSJFileInput
                        text="Select your Logo"
                        subtext="A square image under 200k"
                        errortext="Logo image is too large"
                        v-model="logoData">    
                    </OSJFileInput>
                </div>
                <!-- Company -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        Link to Apply for Job
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="applyError"
                        errorMsg="Please add a URL to the application" />
                    <OSJInput
                        placeholdertext="https://example.com"
                        type="url"
                        :error="applyError"
                        v-model="apply">
                    </OSJInput>
                </div>
            </div>
            <!-- END SIDEBAR -->

            <!-- START MAIN COLUMN -->
            <div class="content-main">
                <!-- Title -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        Job Title
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="titleError"
                        errorMsg="Please include the title of the job" />
                    <OSJInput
                        placeholdertext="Job Title"
                        :error="titleError"
                        v-model="title">
                    </OSJInput>
                </div>
                <!-- City -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        City
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="cityError"
                        errorMsg="Please select the city where the job is located" />
                    <OSJInput
                        placeholdertext="City"
                        :error="cityError"
                        v-model="city">
                    </OSJInput>
                </div>
                <!-- State -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        State
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="stateError"
                        errorMsg="Please select a state" />
                    <OSJSelect
                        :options="statelist"
                        v-model="state">
                    </OSJSelect>
                </div>

                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        subtext="Youtube embed ID">
                        Video
                    </OSJLabel>
                    <OSJInput
                        v-model="embedid">
                    </OSJInput>
                </div>

                <!-- Description -->
                <div class="form-group">

                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        Description
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="descError"
                        errorMsg="Please enter a descriptive job description" />
                    <Editor
                        initialValue="<p>Please enter a descriptive job description</p>"
                        apiKey="63nx0behp7r95lqsc5awpv1cqytfwerk6gwwf3gggzfmnvet"
                        :init="{
                            height: 500,
                            plugins: [
                                'advlist autolink lists link image charmap',
                                'searchreplace visualblocks code fullscreen',
                                'print preview anchor insertdatetime media',
                                'paste code help wordcount table'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic | \
                                alignleft aligncenter alignright | \
                                bullist numlist outdent indent | help'
                        }"
                        v-model="desc"
                      >
                      </Editor>
                </div>

                <div class="form-group">

                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required>
                        How is this and Open Source Job?
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="descError"
                        errorMsg="Please tell candidates what makes this an Open Source Job" />
                    <Editor
                        initialValue="<p>Please explain what makes this an open source job</p>"
                        apiKey="63nx0behp7r95lqsc5awpv1cqytfwerk6gwwf3gggzfmnvet"
                        :init="{
                            height: 300,
                            plugins: [
                                'advlist autolink lists link image charmap',
                                'searchreplace visualblocks code fullscreen',
                                'print preview anchor insertdatetime media',
                                'paste code help wordcount table'
                            ],
                            toolbar:
                                'undo redo | formatselect | bold italic | \
                                alignleft aligncenter alignright | \
                                bullist numlist outdent indent | help'
                        }"
                        v-model="osdesc"
                      >
                      </Editor>
                </div>

                <!-- Type -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size"
                        required
                        subtext="Select one">
                        Employment Type
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="tagsError"
                        errorMsg="Please select one option" />
                    <OSJCheckboxGroup
                        :limit=1
                        :columns=2
                        name="types"
                        :items="typelist"
                        :theme="theme"
                        :size="size"
                        v-model="types">
                    </OSJCheckboxGroup>
                </div>

                <!-- Remote -->
                <div class="form-group">
                    <OSJLabel
                        :theme="theme"
                        :size="size">
                        Remote
                    </OSJLabel>
                    <OSJCheckbox
                        label="This is a Remote Position"
                        :theme="theme"
                        :size="size"
                        v-model="remote">
                    </OSJCheckbox>
                </div>

                <!-- Tags -->
                <div class="form-group">
                    <OSJLabel
                        required
                        subtext="Select between one and five options"
                        :theme="theme"
                        :size="size">
                        Job Tags
                    </OSJLabel>
                    <OSJErrorMsg
                        :error="tagsError"
                        errorMsg="Please between one and five options" />
                    <OSJCheckboxGroup
                        :limit=5
                        :columns=2
                        name="tags"
                        :items="taglist"
                        :theme="theme"
                        :size="size"
                        v-model="tags">
                    </OSJCheckboxGroup>
                </div>

                <div class="form-group form-group-footer">
                    <!-- Submit the form -->
                    <div class="side">
                        <Btn @clicked="validateForm">Submit</Btn>
                    </div>
                </div>
            </div>
            <!-- END MAIN COLUMN -->
        </div>
    </PageFrame>
</template>

<script>
    import firebase from "firebase/app";
    import "firebase/firestore"

    import Editor from '@tinymce/tinymce-vue'
    
    import he from 'he'
    import PageFrame from '@/components/PageFrame.vue'
    import Btn from '@/components/Btn.vue'
    import OSJCheckbox from '@/components/OSJCheckbox.vue'
    import OSJCheckboxGroup from '@/components/OSJCheckboxGroup.vue'
    import OSJLabel from '@/components/OSJLabel.vue'
    import OSJFileInput from '@/components/OSJFileInput.vue'
    import OSJInput from '@/components/OSJInput.vue'
    import OSJSelect from '@/components/OSJSelect.vue'
    import OSJErrorMsg from '@/components/OSJErrorMsg.vue'

    import { taglist, typelist, statelist } from '@/data/lists.json'
    import { format } from 'date-fns'

    export default {
        name: "add",
        components : {
            PageFrame,
            OSJCheckbox,
            OSJCheckboxGroup,
            OSJLabel,
            OSJFileInput,
            OSJInput,
            OSJSelect,
            OSJErrorMsg,
            Btn,
            Editor
        },
        data: function(){
            return {
                taglist,
                typelist,
                statelist,
                // user inputs
                tags: [],
                types: [],
                city: "",
                state: "",
                desc: "",
                osdesc: "",
                title: "",
                company: "",
                apply: "",
                logoData: "",
                embedid: "",

                remote: false,
                owner: '',
                editor: undefined,
                // errors
                titleError: false,
                applyError: false,
                companyError: false,
                cityError: false,
                tagsError: false,
                typesError: false,
                descError: false,
                osDescError: false,
                stateError: false,

                docId: '',
                loaded: false,
                created: '',
                expires: '',
                expiresPretty: '',
                theme: 'dark',
                size: 'small'
            }
        },

        beforeMount(){
            const id = this.$route.params.id
            
            this.$store.dispatch('getJobById', id).then( ({ job, docId }) => {

                if( job.uid !== firebase.auth().currentUser.uid ){
                    this.$router.push( { path : '/dashboard' } );
                }

                this.job      = job
                this.docId    = docId

                this.desc     = he.decode( job.desc ? job.desc : "" )
                this.osdesc   = he.decode( job.osdesc ? job.osdesc : "" )

                this.title    = job.title
                this.company  = job.company
                this.apply    = job.apply
                this.city     = job.city
                this.state    = job.state
                this.types    = job.type
                this.remote   = job.remote || false
                this.logoData = job.logoData
                this.tags     = job.tags
                this.expires  = job.expires
                this.created  = job.created
                this.embedid  = job.embed
                this.id       = job.id
            })
        },
        computed: {
            formattedDate () {
                return format( this.expires || new Date(), 'M/d/yyyy' )
            },
            createdDate () {
                return format( this.created || new Date(), 'M/d/yyyy' )
            }
        },
        methods: {
            validateForm ({event}) {
                event.preventDefault();
                if ( this.formFilled() ) {
                    const payload = {
                        edits : {
                            owner    : firebase.auth().currentUser.email,
                            uid      : firebase.auth().currentUser.uid,
                            desc     : he.encode( this.desc ),
                            osdesc   : he.encode( this.osdesc ),
                            title    : this.title,
                            city     : this.city,
                            state    : this.state,
                            company  : this.company,
                            logoData : this.logoData,
                            tags     : this.tags,
                            apply    : this.apply,
                            remote   : this.remote,
                            type     : this.types,
                            expires  : this.expires,
                            embed    : this.embedid 
                        },
                        docId : this.docId
                    }
                    this.$store
                        .dispatch( 'editJob', payload )
                        .then(() => this.$router.replace('/dashboard'))
                }else{
                    this.applyErrorCodes()
                }
            },
            testDesc ( str ) {
                return str === "" || str.length < 60
            },
            formFilled () {
                return this.city    !== ""
                    && this.state   !== ""
                    && this.title   !== ""
                    && this.company !== ""
                    && this.apply   !== ""
                    && this.desc    !== ""
                    && this.osdesc  !== ""

                    && this.types.length
                    && this.tags.length
            },
            applyErrorCodes(){
                // validate form and error colors
                this.titleError   = this.title   === ""
                this.applyError   = this.apply   === ""
                this.companyError = this.company === ""
                this.cityError    = this.city    === ""
                this.stateError   = this.state   === ""
                this.tagsError    = this.tags.length < 1
                this.typesError   = this.types.length < 1
                this.termsError   = !this.terms
                this.descError    = this.testDesc(this.desc)
                this.osDescError  = this.testDesc( this.osdesc )
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/vars";
    @import "../scss/fileinput";
    @import "../scss/select-wrapper";

    .content {
        @media screen and (min-width: $b1){
            display: flex;
        }

        &-main{
            @media screen and (min-width: $b1){
                flex-grow: 1;
            }
        }

        &-sidebar{
            @media screen and (min-width: $b1){
                margin-right: 4rem;
                flex-basis: 26rem;
                flex-shrink: 0;
                flex-grow: 0;
            }
        }
    }
    .form-group{
        margin-bottom: 2rem;  
    }
</style>